import React, {useState} from 'react'
import EditButton from '../../../shared/actionButtons/EditButton'
import ProffessionalSummaryModal from './EditModals/ProffessionalSummaryModal'
import TitleModal from './EditModals/TitleModal'

type Props = {}

const ProffessionalSummary = (props: Props) => {
  const [proffessionalSummEditModal, setproffessionalSummEditModal] = useState(false)
  const handleproffessionalSummEditModal = () => {
    setproffessionalSummEditModal(!proffessionalSummEditModal)
  }

  const [titleModal, setTitleModal] = useState(false)
  const handleTitleModal = () => {
    setTitleModal(!titleModal)
  }
  return (
    <div className='card-body pt-9 pb-0 '>
      <ProffessionalSummaryModal
        handleEditModal={handleproffessionalSummEditModal}
        editModal={proffessionalSummEditModal}
      />
      <TitleModal handleEditModal={handleTitleModal} editModal={titleModal} />
      <div className='d-flex'>
        <span className='fs-2 fw-bold text-gray-900'>
          {' '}
          Full stack web app - MERN and android developer
        </span>
        <EditButton handleEditModal={handleTitleModal} className='mx-3' />
      </div>
      <div className='d-flex mt-3 text-gray-700 fs-6 '>
        <p>
          Hi there, I'm here to help you map your ideas into reality. By hiring me you'll get a
          dedicated, passionate programmer that strives to bring your ideas alive. I make friction
          removing, problem-solving product with high usability rate. You are only one handshake
          away from an amazing app{' '}
          <EditButton handleEditModal={handleproffessionalSummEditModal} className='mx-3' />
        </p>
      </div>
    </div>
  )
}

export default ProffessionalSummary
